export const TEST_STRIPS_SKU = "ascensia_contour_test_strip";
